export default __webpack_public_path__ + "static/0-4625c816b7441ec2c9de93d05be39741.png";